<template>
	<div>
		<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
		 :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				eachPage: 10,
				indexPage:0
			}
		},
		props: {
			changePage:{
				type:Function,
				default:function(){}
			},
			allpage:{
				type:Number,
				default:10
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.changePage(this.indexPage,this.eachPage)
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = (val - 1) * this.eachPage;
				this.changePage(this.indexPage,this.eachPage)
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/pagination/index.vue